export default __webpack_public_path__ + "static/media/face_1_40.ae46ad70.png";